import request from 'utils/request'
// 添加或者编辑
export const add = data => request().post('sysSegment/add', data)

// 删除
export const remove = id => request().get(`sysSegment/delete/${id}`)

// 获取表格数据
export const getTableData = data => request().post('sysSegment/page', data)

// 获取业务类型列表
export const getBusinessList = () => request().get('business/jsonList')

// 冻结
export const freeze = id => request().get(`sysSegment/freeze/${id}`)

// 解冻
export const thaw = id => request().get(`sysSegment/thaw/${id}`)

// 获取业务类型列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')
